// extracted by mini-css-extract-plugin
export var askAiIcon = "_oc-k";
export var category = "_oc-a";
export var categoryHeader = "_oc-f";
export var container = "_oc-0";
export var group = "_oc-b";
export var groupItems = "_oc-g";
export var groupSeparator = "_oc-l";
export var highlight = "_oc-8";
export var loading = "_oc-1";
export var noResults = "_oc-3";
export var placeholder = "_oc-2";
export var resultContent = "_oc-5";
export var resultIcon = "_oc-d";
export var resultItem = "_oc-h";
export var resultMeta = "_oc-9";
export var resultSubtitle = "_oc-7";
export var resultSuffix = "_oc-j";
export var resultTitle = "_oc-6";
export var resultsList = "_oc-4";
export var searchGroup = "_oc-e";
export var selected = "_oc-i";
export var subgroup = "_oc-c";